var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST, getBulkWeightDiscrepancyDataFailure, getBulkWeightDiscrepancyDataSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const getBulkWeightDiscrepancy = (action) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("getWeightDiscrepancy action", action.payload);
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const { tenantId, pageSize, pageOffset } = action.payload;
        try {
            APIIN.get(`/report/admin/weight/dispute/batch/list?tenantId=${tenantId}&pageSize=${pageSize}&pageOffset=${pageOffset}`)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getBulkWeightDiscrepancyWorker(action) {
    try {
        const data = yield call(getBulkWeightDiscrepancy, action);
        yield put(getBulkWeightDiscrepancyDataSuccess(data));
    }
    catch (error) {
        yield put(getBulkWeightDiscrepancyDataFailure(error));
    }
}
export function* watchGetBulkWeightDiscrepancyData() {
    yield takeLatest(GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST, getBulkWeightDiscrepancyWorker);
}
